import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=6c673d21&scoped=true&"
import script from "./MenuIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MenuIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c673d21",
  null
  
)

export default component.exports